import "./style.css";

const About = () => {
  return (
    <div className="contact">
      <h1>Contact me!</h1>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3380.4749366538927!2d34.826501620856135!3d32.08344738127915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d4a315b76ac0b%3A0xde0d37c00c4e1773!2z15TXqNeQIteUIDcxLCDXqNee16og15LXnw!5e0!3m2!1siw!2sil!4v1630235917012!5m2!1siw!2sil"
        frameBorder="0"
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      >
      </iframe>

      <h4>Phone</h4>
      <p>054 - 3247884</p>

      <h4>Email</h4>
      <p>shanilevi01011@gmail.com</p>

      <h4>Address</h4>
      <p>Ha-roha 71. Ramt-Gam Isreal</p>
    </div>
  );
};

export default About;
